module.exports = __webpack_public_path__ + "img/RAZED.df2744da.svg";